import { PasskeyAction } from '@shared/enums';
import { ThirdPartyProvider } from '@shared/enums/third-party-provider.enum';
import type { PasskeyThirdPartyPayload, ThirdPartyPayload } from '@shared/models';
import type { ThirdPartyProviderContract } from './types';

const passkeyActionEntries = Object.values(PasskeyAction).map((passkeyAction): [string, PasskeyAction] => [
  passkeyAction,
  passkeyAction,
]);
const passkeyActionLookup: Record<string, PasskeyAction> = Object.fromEntries(passkeyActionEntries);

export const parsePasskeyActionParam = (action: Nullable<string>): Nullable<PasskeyAction> => {
  if (!action) {
    return undefined;
  }

  return passkeyActionLookup[action];
};

const isPasskeyPayload = (payload: ThirdPartyPayload): payload is PasskeyThirdPartyPayload =>
  'action' in payload && payload.provider === ThirdPartyProvider.Passkey;

export const passkeyProviderContract: ThirdPartyProviderContract = {
  provider: ThirdPartyProvider.Passkey,
  parse: ({ commonPayload, searchParams }) => {
    const action = parsePasskeyActionParam(searchParams.get('action'));
    if (!action) {
      return undefined;
    }

    return {
      ...commonPayload,
      provider: ThirdPartyProvider.Passkey,
      action,
      state: searchParams.get('state') ?? undefined,
      ceremonyId: searchParams.get('ceremonyId') ?? undefined,
      optionsJson: searchParams.get('optionsJson') ?? undefined,
      optionsHandoffKey: searchParams.get('optionsHandoffKey') ?? undefined,
      account: searchParams.get('account') ?? undefined,
    };
  },
  validate: (payload) => {
    if (!isPasskeyPayload(payload)) {
      return {
        ready: false,
        fallbackRedirectUrl: payload.redirectUrl,
      };
    }

    const hasBaseFields = Boolean(payload.redirectUrl && payload.action);
    const hasForgotAccount = payload.action !== PasskeyAction.ForgotPasswordVerify || Boolean(payload.account?.trim());

    return {
      ready: hasBaseFields && hasForgotAccount,
      fallbackRedirectUrl: payload.redirectUrl,
    };
  },
};
